export var AppType;
(function (AppType) {
    AppType["Assortment"] = "Assortment";
    AppType["TDAnalysis"] = "TDAnalysis";
    AppType["Configurator"] = "Configurator";
    AppType["Allocation"] = "Allocation";
    AppType["FinancialPlanning"] = "FinancialPlanning";
})(AppType || (AppType = {}));
export function tenantTabHasPathSlot(tab) {
    return tab.pathSlot !== undefined;
}
